export const buildTabA11yProps = (index: number | string) => ({
  'aria-controls': `tabpanel-${index}`,
  id: `tab-${index}`,
});

export const buildTabPanelA11yProps = (index: number | string) => ({
  'aria-labelledby': `tab-${index}`,
  id: `tabpanel-${index}`,
});
